interface ToastMessage {
  title: string;
  description: string;
  variant?: "default" | "destructive";
}

interface ModalConfig {
  title: string;
  description: (name: string) => string;
  confirmText: string;
}

interface UsersTabMessages {
  BLOCK: { SUCCESS: ToastMessage; MODAL: ModalConfig };
  UNBLOCK: { SUCCESS: ToastMessage; MODAL: ModalConfig };
  RESET_PASSWORD: {
    SUCCESS: ToastMessage;
    MODAL: ModalConfig;
    ERROR: ToastMessage;
  };
  TOGGLE: { ERROR: ToastMessage };
  AUDIT_HISTORY: { ERROR: ToastMessage };
}

export const USER_DEFAULT_PASSWORD = "12345";

export const USERS_TAB_MESSAGES: UsersTabMessages = {
  BLOCK: {
    SUCCESS: {
      title: "Sucesso",
      description: "Usuário bloqueado com sucesso",
    },
    MODAL: {
      title: "Bloquear Usuário",
      description: (name: string) =>
        `Tem certeza que deseja bloquear o usuário "${name}"?`,
      confirmText: "Bloquear",
    },
  },
  UNBLOCK: {
    SUCCESS: {
      title: "Sucesso",
      description: "Usuário desbloqueado com sucesso",
    },
    MODAL: {
      title: "Desbloquear Usuário",
      description: (name: string) =>
        `Tem certeza que deseja desbloquear o usuário "${name}"?`,
      confirmText: "Desbloquear",
    },
  },
  RESET_PASSWORD: {
    SUCCESS: {
      title: "Sucesso",
      description: "Senha resetada com sucesso",
    },
    MODAL: {
      title: "Resetar Senha",
      description: (name: string) =>
        `A senha do usuário "${name}" será resetada para: ${USER_DEFAULT_PASSWORD}. Deseja continuar?`,
      confirmText: "Resetar Senha",
    },
    ERROR: {
      title: "Erro",
      description: "Erro ao resetar senha. Tente novamente.",
      variant: "destructive",
    },
  },
  TOGGLE: {
    ERROR: {
      title: "Erro",
      description: "Erro ao executar ação. Tente novamente.",
      variant: "destructive",
    },
  },
  AUDIT_HISTORY: {
    ERROR: {
      title: "Erro",
      description: "Erro ao buscar histórico.",
      variant: "destructive",
    },
  },
};
